var _title, _desc, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgIconCheck = function SvgIconCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "Group 8")), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Portal-App",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard-Weekly",
    transform: "translate(-152.000000, -293.000000)",
    stroke: "#FF6B00"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(15.500000, 217.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(1.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(136.500000, 77.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path-15",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "4 8.5 7 11 12 6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 16,
    height: 16,
    rx: 8
  }))))))));
};

export default __webpack_public_path__ + "static/media/icon-check.4197aa46.svg";
export { SvgIconCheck as ReactComponent };